import makeSlice from '@web/slices/abTest/sliceMaker'

const abTestSlice = makeSlice()

export default abTestSlice.reducer
